// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-radio-group[data-v-0c80f9d0]::part(form-control-input){display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
